import { merge } from 'lodash-es';

import { SpacingProps } from '../../styles/getSpacingSprinkles.js';
import { spacingToCss } from '../helpers/spacingToCss.js';
import type { PaddingCSS, DefaultPadding } from '../types/layout.types.js';

const defaultPadding: DefaultPadding = {
  padding: 0,
  paddingTop: 0,
  paddingRight: 0,
  paddingBottom: 0,
  paddingLeft: 0,
};

/**
 * Generates CSS padding properties based on the provided padding props and default padding values.
 * @internal
 */
export const usePaddingProps = (
  props: SpacingProps,
  defaultPaddingProps: DefaultPadding = defaultPadding,
): PaddingCSS => {
  const {
    padding,
    p,
    paddingX,
    px,
    paddingY,
    py,
    paddingTop,
    pt,
    paddingRight,
    pr,
    paddingBottom,
    pb,
    paddingLeft,
    pl,
  } = props;

  const convertedDefaultPaddingProps = {
    paddingTop: spacingToCss(
      defaultPaddingProps.paddingTop ?? defaultPaddingProps.padding,
    ),
    paddingLeft: spacingToCss(
      defaultPaddingProps.paddingLeft ?? defaultPaddingProps.padding,
    ),
    paddingBottom: spacingToCss(
      defaultPaddingProps.paddingBottom ?? defaultPaddingProps.padding,
    ),
    paddingRight: spacingToCss(
      defaultPaddingProps.paddingRight ?? defaultPaddingProps.padding,
    ),
  };

  return merge({}, convertedDefaultPaddingProps, {
    paddingTop: spacingToCss(
      pt ?? paddingTop ?? py ?? paddingY ?? p ?? padding,
    ),
    paddingRight: spacingToCss(
      pr ?? paddingRight ?? px ?? paddingX ?? p ?? padding,
    ),
    paddingBottom: spacingToCss(
      pb ?? paddingBottom ?? py ?? paddingY ?? p ?? padding,
    ),
    paddingLeft: spacingToCss(
      pl ?? paddingLeft ?? px ?? paddingX ?? p ?? padding,
    ),
  });
};
